// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"36":"f372a5ea1dddbaa38f98","218":"dbab66304bcdc1e74b98","231":"0c65f3efa02f6cadb860","691":"93b2d7ae98156b9f837b","774":"89cfe43b7b3505c4f4e2"}[chunkId] + ".js";
};